// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wM-z","isFullWidth":"xM-z","landingPageVideo":"yM-z","play":"zM-z","iframeVideo":"AM-z","playHidden":"BM-z","fullwidth":"CM-z"};